import { Environment } from './interface';
import { firebaseConfig } from './firebase/prod';

export const environment: Environment = {
  production: true,
  environment: 'production',
  apiUrl: 'https://backend.fleetchaser.com/',
  cmsUrl: 'https://fleetchaser.com/',
  apiDomain: 'backend.fleetchaser.com',
  eventSourceHost: 'https://live.fleetchaser.com',
  googleMapsApiKey: 'AIzaSyCLU1UttoCuJrWPSr7KuBDcRCGAQBuRE4Q',
  amplitudeApiKey: 'dadc91607609b440163b3ff9da72fbb2',
  sentry: 'https://847fea33d2f440d397bb19641f5f8fea@sentry.io/269708',
  filesApi: 'https://files.fleetchaser.com',
  sentryEnvironment: 'production',
  googleAnalyticsApiKey: 'GTM-KTC56G8X',

  aeris: {
    id: 'JZsbuN8s8LiApFQzTrWrg',
    secret: 'yTNbERS9LlxJRZoufJcBh9dDVCCPgXUd2YQd08wB',
  },
  tigerService: 'https://tiger.fleetchaser.com/api/v1/tiger/',
  valhallaUrl: 'https://valhalla.fleetchaser.com',
  hubspotHubId: '6250747',
  firebaseConfig: firebaseConfig,
  vapidKey:
    'BAnerMt-Qa6fG8vIu4HAJKz24sFA75tzxQTni-ziBPGcolM-R-4wvyNpTrmUVVw9EvHE-Orxuf5_6soogLYW0nQ',
  chatWsUrl: 'wss://chat.fleetchaser.com/ws?token=',
  webrtcUrl: 'https://hgateway.fleetchaser.com',
  tus: 'https://uploads.fleetchaser.com/files/',
};
